'use client';

import type { TermsPageType } from '@/utils/isTermsPageType';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import TermCommonPage from '@/components/apps/pages/terms/TermCommonPage';

export default function TermsPageClient({
  content,
  termType,
}: {
  content: string;
  termType: TermsPageType;
}) {
  return (
    <ResponsiveLayout
      desktopPadding={{ top: '100px', bottom: '0' }}
      mobilePadding={{ top: '40px', bottom: '0' }}
    >
      <TermCommonPage content={content} type={termType} />
    </ResponsiveLayout>
  );
}
